module.exports = __webpack_public_path__ + "static/media/Done.483e67b2.svg";